import React from 'react';
import { LucideIcon } from '../UI/LucideIcon';

// ── ErrorBoundary — sem isto, qualquer erro de renderização (ou chunk de
// página que não carregou, ver services/lazyComRetry.js) desmontava a árvore
// inteira do React e sobrava uma tela branca até o F5. Aqui a tela vira um
// aviso com "Recarregar". `resetKey` (App.jsx passa o pathname): navegar pra
// outra rota limpa o erro, então o menu continua funcionando sem recarregar.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    // eslint-disable-next-line no-console
    console.error('Erro de renderização capturado pelo ErrorBoundary:', erro, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.erro && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ erro: null });
    }
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f6f8fc', padding: 16, boxSizing: 'border-box' }}>
        <div className="lev-card" role="alert" style={{ maxWidth: 420, width: '100%', padding: '32px 28px', textAlign: 'center' }}>
          <span style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,72,72,.12)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
            <LucideIcon name="alert-triangle" size={20} color="var(--danger)"/>
          </span>
          <h2 style={{ fontSize: 20, margin: '0 0 8px', color: 'var(--brand-indigo)' }}>Algo deu errado ao abrir esta tela</h2>
          <p style={{ fontSize: 13.5, color: 'var(--gray-600)', lineHeight: 1.55, margin: '0 0 22px' }}>
            Pode ser uma versão nova do portal publicada enquanto esta aba estava aberta. Recarregar costuma resolver.
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button type="button" className="lev-btn-primary" onClick={() => window.location.reload()}>
              <LucideIcon name="refresh-cw" size={16} color="#fff"/> Recarregar
            </button>
            <button type="button" className="lev-btn-ghost" onClick={() => window.location.assign('/')}>
              Ir para o início
            </button>
          </div>
        </div>
      </div>
    );
  }
}
